export default "__VITE_ASSET__fRboOI3b__"